const fromTextToBase64parser = (text) => {
	return text ? btoa(encodeURIComponent(text)) : ""
}

const fromBase64ToTextParser = (text) => {
	return text ? decodeURIComponent(atob(text)) : ""
}

module.exports = { fromTextToBase64parser, fromBase64ToTextParser }
